export default {
  name: 'vi',
  el: {
    breadcrumb: {
      label: 'Đường dẫn',
    },
    colorpicker: {
      confirm: 'OK',
      clear: 'Xóa',
      defaultLabel: 'bộ chọn màu',
      description: 'màu hiện tại là {color}. nhấn enter để chọn màu mới.',
      alphaLabel: 'chọn độ trong suốt',
      alphaDescription: 'độ trong suốt {alpha}, màu hiện tại là {color}',
      hueLabel: 'chọn tông màu',
      hueDescription: 'tông màu {hue}, màu hiện tại là {color}',
      svLabel: 'chọn độ bão hòa và độ sáng',
      svDescription:
        'độ bão hòa {saturation}, độ sáng {brightness}, màu hiện tại là {color}',
      predefineDescription: 'chọn {value} làm màu',
    },
    datepicker: {
      now: 'Hiện tại',
      today: 'Hôm nay',
      cancel: 'Hủy',
      clear: 'Xóa',
      confirm: 'OK',
      dateTablePrompt: 'Sử dụng các phím mũi tên và enter để chọn ngày',
      monthTablePrompt: 'Sử dụng các phím mũi tên và enter để chọn tháng',
      yearTablePrompt: 'Sử dụng các phím mũi tên và enter để chọn năm',
      selectedDate: 'Ngày đã chọn',
      selectDate: 'Chọn ngày',
      selectTime: 'Chọn giờ',
      startDate: 'Ngày bắt đầu',
      startTime: 'Thời gian bắt đầu',
      endDate: 'Ngày kết thúc',
      endTime: 'Thời gian kết thúc',
      prevYear: 'Năm trước',
      nextYear: 'Năm tới',
      prevMonth: 'Tháng trước',
      nextMonth: 'Tháng tới',
      year: 'Năm',
      month1: 'Tháng 1',
      month2: 'Tháng 2',
      month3: 'Tháng 3',
      month4: 'Tháng 4',
      month5: 'Tháng 5',
      month6: 'Tháng 6',
      month7: 'Tháng 7',
      month8: 'Tháng 8',
      month9: 'Tháng 9',
      month10: 'Tháng 10',
      month11: 'Tháng 11',
      month12: 'Tháng 12',
      weeks: {
        sun: 'CN',
        mon: 'T2',
        tue: 'T3',
        wed: 'T4',
        thu: 'T5',
        fri: 'T6',
        sat: 'T7',
      },
      weeksFull: {
        sun: 'Chủ nhật',
        mon: 'Thứ hai',
        tue: 'Thứ ba',
        wed: 'Thứ tư',
        thu: 'Thứ năm',
        fri: 'Thứ sáu',
        sat: 'Thứ bảy',
      },
      months: {
        jan: 'Th.1',
        feb: 'Th.2',
        mar: 'Th.3',
        apr: 'Th.4',
        may: 'Th.5',
        jun: 'Th.6',
        jul: 'Th.7',
        aug: 'Th.8',
        sep: 'Th.9',
        oct: 'Th.10',
        nov: 'Th.11',
        dec: 'Th.12',
      },
    },
    inputNumber: {
      decrease: 'giảm số',
      increase: 'tăng số',
    },
    select: {
      loading: 'Đang tải',
      noMatch: 'Dữ liệu không phù hợp',
      noData: 'Không có dữ liệu',
      placeholder: 'Chọn',
    },
    mention: {
      loading: 'Đang tải',
    },
    dropdown: {
      toggleDropdown: 'Bật/tắt menu thả xuống',
    },
    cascader: {
      noMatch: 'Dữ liệu không phù hợp',
      loading: 'Đang tải',
      placeholder: 'Chọn',
      noData: 'Không có dữ liệu',
    },
    pagination: {
      goto: 'Đến trang',
      pagesize: '/trang',
      total: 'Tổng {total}',
      pageClassifier: '',
      page: 'Trang',
      prev: 'Đến trang trước',
      next: 'Đến trang sau',
      currentPage: 'trang {pager}',
      prevPages: '{pager} trang trước',
      nextPages: '{pager} trang sau',
      deprecationWarning:
        'Phát hiện cách sử dụng không còn được hỗ trợ, vui lòng tham khảo tài liệu el-pagination để biết thêm chi tiết',
    },
    dialog: {
      close: 'Đóng hộp thoại này',
    },
    drawer: {
      close: 'Đóng hộp thoại này',
    },
    messagebox: {
      title: 'Thông báo',
      confirm: 'OK',
      cancel: 'Hủy',
      error: 'Dữ liệu không hợp lệ',
      close: 'Đóng hộp thoại này',
    },
    upload: {
      deleteTip: 'Nhấn xoá để xoá',
      delete: 'Xóa',
      preview: 'Xem trước',
      continue: 'Tiếp tục',
    },
    slider: {
      defaultLabel: 'thanh trượt giữa {min} và {max}',
      defaultRangeStartLabel: 'chọn giá trị bắt đầu',
      defaultRangeEndLabel: 'chọn giá trị kết thúc',
    },
    table: {
      emptyText: 'Không có dữ liệu',
      confirmFilter: 'Xác nhận',
      resetFilter: 'Làm mới',
      clearFilter: 'Tất cả',
      sumText: 'Tổng',
      selectAllLabel: 'Chọn tất cả các hàng',
      selectRowLabel: 'Chọn hàng này',
      expandRowLabel: 'Mở rộng hàng này',
      collapseRowLabel: 'Thu gọn hàng này',
      sortLabel: 'Sắp xếp theo {column}',
      filterLabel: 'Lọc theo {column}',
    },
    tag: {
      close: 'Đóng thẻ này',
    },
    tour: {
      next: 'Tiếp',
      previous: 'Trước',
      finish: 'Hoàn thành',
      close: 'Đóng hộp thoại này',
    },
    tree: {
      emptyText: 'Không có dữ liệu',
    },
    transfer: {
      noMatch: 'Dữ liệu không phù hợp',
      noData: 'Không có dữ liệu',
      titles: ['Danh sách 1', 'Danh sách 2'],
      filterPlaceholder: 'Nhập từ khóa',
      noCheckedFormat: '{total} mục',
      hasCheckedFormat: '{checked}/{total} đã chọn',
    },
    image: {
      error: 'LỖI',
    },
    pageHeader: {
      title: 'Quay lại',
    },
    popconfirm: {
      confirmButtonText: 'Có',
      cancelButtonText: 'Không',
    },
    carousel: {
      leftArrow: 'Mũi tên qua trái',
      rightArrow: 'Mũi tên qua phải',
      indicator: 'Chuyển carousel đến mục {index}',
    },
    inputOTP: {
      groupLabel: 'OTP Input', // to be translated
      defaultLabel: 'Please enter OTP character {index}', // to be translated
    },
  },
}
